import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ["en", "es"],
    nonExplicitSupportedLngs: true,
    ns: ["translation2"],
    defaultNS: "translation2",
  })

export async function loadListFormatPolyfill(locale: string): Promise<any> {
  if (!("ListFormat" in Intl)) {
    await import("@formatjs/intl-listformat/polyfill")
  }

  if (
    // @ts-ignore - Ignore TypeScript error for the check
    Intl.ListFormat &&
    // @ts-ignore - Ignore TypeScript error for the check
    !Intl.ListFormat.supportedLocalesOf([locale]).includes(locale)
  ) {
    try {
      await import(`@formatjs/intl-listformat/locale-data/${locale}`)
    } catch (e) {
      const baseLocale = locale.split("-")[0]
      await import(`@formatjs/intl-listformat/locale-data/${baseLocale}`)
    }
  }

  // @ts-ignore - Ignore TypeScript error for the check
  return new Intl.ListFormat(locale)
}

i18n.on("initialized", () => {
  loadListFormatPolyfill(i18n.language)
})

i18n.on("languageChanged", (lng) => {
  loadListFormatPolyfill(lng)
  document.documentElement.lang = lng
})

export default i18n
